import OnahButton from 'components/OnahButton';
import OnahTypography from 'components/OnahTypography';
import React, { FC, useState } from 'react';

type Props = {
    permission: Array<string>;
};
const Permissions: FC<Props> = ({permission}) => {
    const [hasRequestedPermission, setHasRequestPermission] = useState(false);

    const onRequestAccess = () => {
        setHasRequestPermission(true);
    }

    return (
        <div className="">
            <OnahTypography className="mb-4" variant="textXl">{hasRequestedPermission ? 'You have requested access to this page' : 'You need permission to view this page'}</OnahTypography>
            <OnahTypography className="mb-4" variant="textSm">{hasRequestedPermission ? 'Contact your super admin to grant you access' : 'Email the account owner to get access to this page.'}</OnahTypography>
            {!hasRequestedPermission && (
                <div className="flex justify-center items-center space-x-2">
                    <OnahButton onClick={onRequestAccess} className="!text-sm !py-2">Request access</OnahButton>
                    <OnahButton className="!text-sm !py-2 !bg-white border">Learn more</OnahButton>
                </div>
            )}

        </div>
    )
};

export default Permissions;